// in case we want a home page in the future
export default function Home(){

    return (
        <div>
            HOME
        </div>
    );
}
